import { remove } from '@webapp-next/lib/request/webapp/apiv2';

export default async function deleteShift(id) {
  try {
    const url = `/api/management/v2/shifts/${id}`;
    const response = await remove(url).then(res => res.data);
    return {
      success: response.success,
      metadata: response.metadata,
    };
  } catch (error) {
    console.error('deleteShift failed', error);
    return { success: false };
  }
}
